import { useTheme } from '@mui/material/styles';
import { getHubSectionStyles } from '../theme/hubThemes';
import { HUB_TYPES } from '../utils/hubRoutes';

export function useHubStyles(hubType = HUB_TYPES.PROJECT_MANAGEMENT) {
    const theme = useTheme();
    const darkMode = theme.palette.mode === 'dark';
    return getHubSectionStyles(hubType, darkMode);
}

export function usePmHubStyles() {
    return useHubStyles(HUB_TYPES.PROJECT_MANAGEMENT);
}
